import useAPI from '@/hooks/useAPI';
import ProgramRepository from '@/repositories/ProgramRepository';

const useIntakeRejectionReasons = (enabled = true) => {
  const programRepository = ProgramRepository();

  return useAPI({
    queryKey: ['getIntakeRejectionReasons'],
    queryFn: async () => {
      return await programRepository.getIntakeRejectionReasons();
    },
    enabled
  });
};

export default useIntakeRejectionReasons;
